import { Action } from "./actions"
import { TerramapApi } from "./api"
import { MapContext } from "./map/mapContext"

export const TerramapContext = React.createContext({

    api: undefined as TerramapApi,

    mapContext: undefined as MapContext,

    close: undefined as (result?: any) => void,

    dispatch: undefined as React.Dispatch<Action>

})

